import { useLocation } from 'react-router-dom';
import { usePackages } from '../../hooks/react-query/use-package';
import Loader from '../shared/loader';
import Error from '../shared/error';
import { APIErrorType } from '../../api';
import { CartProvider } from '../../context/cart/provider';
import Store from './store';
import Segment from '../shared/segment';

function StoreContainer() {
  const location = useLocation();

  const { isLoading, isError, error, data: packages } = usePackages(location.search);
  if (isError) return <Error error={error as APIErrorType} />;
  if (isLoading) return <Loader />;
  if (!packages || packages.length === 0)
    return <Segment textAlign='center'>بسته‌ای برای فروش یافت نشد.</Segment>;

  return (
    <CartProvider>
      <Store packages={packages} />
    </CartProvider>
  );
}

export default StoreContainer;
